import { Link } from "react-router-dom";
import { Instagram, Facebook, Youtube, Mail, MapPin, Phone, ShieldCheck, Truck, Award } from "lucide-react";

export const Footer = () => {
  return (
    <footer className="bg-[#0d0b09] border-t border-[#D4AF37]/15 mt-24" data-testid="site-footer">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        <div className="grid grid-cols-2 md:grid-cols-3 gap-8 py-10 border-b border-[#D4AF37]/10 text-center md:text-left col-span-2 md:col-span-3">
          {[
            { icon: ShieldCheck, title: "BIS Hallmarked", subtitle: "916 & 750 certified purity" },
            { icon: Award, title: "Certified Diamonds", subtitle: "IGI / GIA authenticated" },
            { icon: Truck, title: "Insured Shipping", subtitle: "Complimentary across India" },
          ].map((t, i) => (
            <div key={i} className="flex items-center gap-3 justify-center md:justify-start">
              <t.icon className="text-[#D4AF37]" size={22} />
              <div>
                <div className="text-[13px] tracking-[0.14em] uppercase text-[#FAF8F5]">{t.title}</div>
                <div className="text-xs text-[#C2B29F]">{t.subtitle}</div>
              </div>
            </div>
          ))}
        </div>

        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 py-16">
          <div className="md:col-span-2">
            <div className="font-serif-luxe text-3xl text-[#FAF8F5] tracking-[0.14em]">
              LAXMI <span className="text-[#D4AF37]">AURA</span> JEWELS
            </div>
            <div className="text-[10px] tracking-[0.4em] uppercase text-[#C2B29F] mt-2 italic">By Lakshya Soni</div>
            <p className="mt-6 text-sm text-[#C2B29F] leading-relaxed max-w-md">
              An atelier for the modern Indian bride and the everyday woman who carries an aura. Every piece is
              hand-finished by our master karigars in Jaipur and hallmarked for lifetime authenticity.
            </p>
            <div className="mt-6 flex items-center gap-4">
              <a href="#" className="text-[#C2B29F] hover:text-[#D4AF37] transition"><Instagram size={18}/></a>
              <a href="#" className="text-[#C2B29F] hover:text-[#D4AF37] transition"><Facebook size={18}/></a>
              <a href="#" className="text-[#C2B29F] hover:text-[#D4AF37] transition"><Youtube size={18}/></a>
            </div>
          </div>

          <div>
            <div className="eyebrow mb-5">The Boutique</div>
            <ul className="space-y-3 text-sm text-[#FAF8F5]/85">
              <li><Link to="/shop" className="hover:text-[#D4AF37]">Shop All</Link></li>
              <li><Link to="/collections" className="hover:text-[#D4AF37]">Collections</Link></li>
              <li><Link to="/shop/bridal" className="hover:text-[#D4AF37]">Bridal</Link></li>
              <li><Link to="/shop/diamond" className="hover:text-[#D4AF37]">Diamond</Link></li>
              <li><Link to="/about" className="hover:text-[#D4AF37]">Our Story</Link></li>
            </ul>
          </div>

          <div>
            <div className="eyebrow mb-5">Care & Trust</div>
            <ul className="space-y-3 text-sm text-[#FAF8F5]/85">
              <li className="flex items-start gap-2"><MapPin size={14} className="mt-1 text-[#D4AF37]"/> Johari Bazaar, Jaipur 302003</li>
              <li className="flex items-start gap-2"><Phone size={14} className="mt-1 text-[#D4AF37]"/> +91 98765 43210</li>
              <li className="flex items-start gap-2"><Mail size={14} className="mt-1 text-[#D4AF37]"/> care@laxmiaura.com</li>
              <li><Link to="/contact" className="hover:text-[#D4AF37]">Book a Private Viewing</Link></li>
            </ul>
          </div>
        </div>

        <div className="py-6 border-t border-[#D4AF37]/10 flex flex-col md:flex-row justify-between items-center gap-2 text-xs text-[#C2B29F]">
          <div>© {new Date().getFullYear()} Laxmi Aura Jewels. Handcrafted with reverence.</div>
          <div className="tracking-[0.24em] uppercase">Founder — Lakshya Soni</div>
        </div>
      </div>
    </footer>
  );
};
